// /state/actions/types.js
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";
export const LOGOUT = "LOGOUT";

export const VERIFY_OTP_REQUEST = "VERIFY_OTP_REQUEST";
export const VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS";
export const VERIFY_OTP_FAILURE = "VERIFY_OTP_FAILURE";

export const DELETE_ACCOUNT_REQUEST = "DELETE_ACCOUNT_REQUEST";
export const DELETE_ACCOUNT_SUCCESS = "DELETE_ACCOUNT_SUCCESS";
export const DELETE_ACCOUNT_FAILURE = "DELETE_ACCOUNT_FAILURE";

export const CONFIRM_PASSWORD_REQUEST = "CONFIRM_PASSWORD_REQUEST";
export const CONFIRM_PASSWORD_SUCCESS = "CONFIRM_PASSWORD_SUCCESS";
export const CONFIRM_PASSWORD_FAILURE = "CONFIRM_PASSWORD_FAILURE";


//User
export const PASSWORD_CHANGE_REQUEST = "PASSWORD_CHANGE_REQUEST";
export const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS";
export const PASSWORD_CHANGE_FAILURE = "PASSWORD_CHANGE_FAILURE";

export const FETCH_USERS_REQUEST = "FETCH_USERS_REQUEST";
export const FETCH_USERS_SUCCESS = "FETCH_USERS_SUCCESS";
export const FETCH_USERS_FAILURE = "FETCH_USERS_FAILURE";

export const FETCH_USER_REQUEST = "FETCH_USER_REQUEST";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const FETCH_USER_FAILURE = "FETCH_USER_FAILURE";

export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_FAILURE = "UPDATE_USER_FAILURE";

export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

//Delivery
export const FETCH_PACKAGES_REQUEST = "FETCH_PACKAGES_REQUEST";
export const FETCH_PACKAGES_SUCCESS = "FETCH_PACKAGES_SUCCESS";
export const FETCH_PACKAGES_FAILURE = "FETCH_PACKAGES_FAILURE";

export const FETCH_DELIVERIES_REQUEST = "FETCH_DELIVERIES_REQUEST";
export const FETCH_DELIVERIES_SUCCESS = "FETCH_DELIVERIES_SUCCESS";
export const FETCH_DELIVERIES_FAILURE = "FETCH_DELIVERIES_FAILURE";

export const UPDATE_DELIVERY_STATUS_REQUEST = "UPDATE_DELIVERY_STATUS_REQUEST";
export const UPDATE_DELIVERY_STATUS_SUCCESS = "UPDATE_DELIVERY_STATUS_SUCCESS";
export const UPDATE_DELIVERY_STATUS_FAILURE = "UPDATE_DELIVERY_STATUS_FAILURE";

export const FETCH_DRIVER_TOTAL_DISTANCE_REQUEST = "FETCH_DRIVER_TOTAL_DISTANCE_REQUEST";
export const FETCH_DRIVER_TOTAL_DISTANCE_SUCCESS = "FETCH_DRIVER_TOTAL_DISTANCE_SUCCESS";
export const FETCH_DRIVER_TOTAL_DISTANCE_FAILURE = "FETCH_DRIVER_TOTAL_DISTANCE_FAILURE";
export const RESET_DRIVER_TOTAL_DISTANCE = "RESET_DRIVER_TOTAL_DISTANCE";

//Size Estimates
export const ADD_SIZE_ESTIMATE_REQUEST = "ADD_SIZE_ESTIMATE_REQUEST";
export const ADD_SIZE_ESTIMATE_SUCCESS = "ADD_SIZE_ESTIMATE_SUCCESS";
export const ADD_SIZE_ESTIMATE_FAILURE = "ADD_SIZE_ESTIMATE_FAILURE";

export const FETCH_SIZE_ESTIMATES_REQUEST = "FETCH_SIZE_ESTIMATES_REQUEST";
export const FETCH_SIZE_ESTIMATES_SUCCESS = "FETCH_SIZE_ESTIMATES_SUCCESS";
export const FETCH_SIZE_ESTIMATES_FAILURE = "FETCH_SIZE_ESTIMATES_FAILURE";

export const FETCH_ALL_SIZE_ESTIMATES_REQUEST = "FETCH_ALL_SIZE_ESTIMATES_REQUEST";
export const FETCH_ALL_SIZE_ESTIMATES_SUCCESS = "FETCH_ALL_SIZE_ESTIMATES_SUCCESS";
export const FETCH_ALL_SIZE_ESTIMATES_FAILURE = "FETCH_ALL_SIZE_ESTIMATES_FAILURE";

export const UPDATE_SIZE_ESTIMATE_REQUEST = 'UPDATE_SIZE_ESTIMATE_REQUEST';
export const UPDATE_SIZE_ESTIMATE_SUCCESS = 'UPDATE_SIZE_ESTIMATE_SUCCESS';
export const UPDATE_SIZE_ESTIMATE_FAILURE = 'UPDATE_SIZE_ESTIMATE_FAILURE';


//Transactions
export const FETCH_TRANSACTIONS_REQUEST = "FETCH_TRANSACTIONS_REQUEST";
export const FETCH_TRANSACTIONS_SUCCESS = "FETCH_TRANSACTIONS_SUCCESS";
export const FETCH_TRANSACTIONS_FAILURE = "FETCH_TRANSACTIONS_FAILURE";

export const REFUND_TRANSACTION_REQUEST = "REFUND_TRANSACTION_REQUEST";
export const REFUND_TRANSACTION_SUCCESS = "REFUND_TRANSACTION_SUCCESS";
export const REFUND_TRANSACTION_FAILURE = "REFUND_TRANSACTION_FAILURE";


//Reviews
export const FETCH_REVIEWS_REQUEST = "FETCH_REVIEWS_REQUEST";
export const FETCH_REVIEWS_SUCCESS = "FETCH_REVIEWS_SUCCESS";
export const FETCH_REVIEWS_FAILURE = "FETCH_REVIEWS_FAILURE";

//Package Evidence
export const FETCH_PACKAGE_EVIDENCES_REQUEST =
  "FETCH_PACKAGE_EVIDENCES_REQUEST";
export const FETCH_PACKAGE_EVIDENCES_SUCCESS =
  "FETCH_PACKAGE_EVIDENCES_SUCCESS";
export const FETCH_PACKAGE_EVIDENCES_FAILURE =
  "FETCH_PACKAGE_EVIDENCES_FAILURE";



//FAQ
export const FETCH_FAQS_REQUEST = "FETCH_FAQS_REQUEST";
export const FETCH_FAQS_SUCCESS = "FETCH_FAQS_SUCCESS";
export const FETCH_FAQS_FAILURE = "FETCH_FAQS_FAILURE";
export const CREATE_FAQ_REQUEST = "CREATE_FAQ_REQUEST";
export const CREATE_FAQ_SUCCESS = "CREATE_FAQ_SUCCESS";
export const CREATE_FAQ_FAILURE = "CREATE_FAQ_FAILURE";
export const UPDATE_FAQ_REQUEST = "UPDATE_FAQ_REQUEST";
export const UPDATE_FAQ_SUCCESS = "UPDATE_FAQ_SUCCESS";
export const UPDATE_FAQ_FAILURE = "UPDATE_FAQ_FAILURE";
export const ARCHIVE_FAQ_REQUEST = "ARCHIVE_FAQ_REQUEST";
export const ARCHIVE_FAQ_SUCCESS = "ARCHIVE_FAQ_SUCCESS";
export const ARCHIVE_FAQ_FAILURE = "ARCHIVE_FAQ_FAILURE";


//Help Topics
export const FETCH_HELP_TOPICS_REQUEST = "FETCH_HELP_TOPICS_REQUEST";
export const FETCH_HELP_TOPICS_SUCCESS = "FETCH_HELP_TOPICS_SUCCESS";
export const FETCH_HELP_TOPICS_FAILURE = "FETCH_HELP_TOPICS_FAILURE";
export const CREATE_HELP_TOPIC_REQUEST = "CREATE_HELP_TOPIC_REQUEST";
export const CREATE_HELP_TOPIC_SUCCESS = "CREATE_HELP_TOPIC_SUCCESS";
export const CREATE_HELP_TOPIC_FAILURE = "CREATE_HELP_TOPIC_FAILURE";
export const UPDATE_HELP_TOPIC_REQUEST = "UPDATE_HELP_TOPIC_REQUEST";
export const UPDATE_HELP_TOPIC_SUCCESS = "UPDATE_HELP_TOPIC_SUCCESS";
export const UPDATE_HELP_TOPIC_FAILURE = "UPDATE_HELP_TOPIC_FAILURE";
export const DELETE_HELP_TOPIC_REQUEST = "DELETE_HELP_TOPIC_REQUEST";
export const DELETE_HELP_TOPIC_SUCCESS = "DELETE_HELP_TOPIC_SUCCESS";
export const DELETE_HELP_TOPIC_FAILURE = "DELETE_HELP_TOPIC_FAILURE";

// Chats
export const CREATE_CHAT_REQUEST = "CREATE_CHAT_REQUEST";
export const CREATE_CHAT_SUCCESS = "CREATE_CHAT_SUCCESS";
export const CREATE_CHAT_FAILURE = "CREATE_CHAT_FAILURE";
export const GET_CHAT_BETWEEN_USERS_REQUEST = "GET_CHAT_BETWEEN_USERS_REQUEST";
export const GET_CHAT_BETWEEN_USERS_SUCCESS = "GET_CHAT_BETWEEN_USERS_SUCCESS";
export const GET_CHAT_BETWEEN_USERS_FAILURE = "GET_CHAT_BETWEEN_USERS_FAILURE";
export const GET_ALL_CHATS_REQUEST = "GET_ALL_CHATS_REQUEST";
export const GET_ALL_CHATS_SUCCESS = "GET_ALL_CHATS_SUCCESS";
export const GET_ALL_CHATS_FAILURE = "GET_ALL_CHATS_FAILURE";
export const MARK_CHAT_AS_READ_REQUEST = "MARK_CHAT_AS_READ_REQUEST";
export const MARK_CHAT_AS_READ_SUCCESS = "MARK_CHAT_AS_READ_SUCCESS";
export const MARK_CHAT_AS_READ_FAILURE = "MARK_CHAT_AS_READ_FAILURE";


//Notifications
export const FETCH_NOTIFICATIONS_REQUEST = "FETCH_NOTIFICATIONS_REQUEST";
export const FETCH_NOTIFICATIONS_SUCCESS = "FETCH_NOTIFICATIONS_SUCCESS";
export const FETCH_NOTIFICATIONS_FAILURE = "FETCH_NOTIFICATIONS_FAILURE";

export const MARK_NOTIFICATION_AS_READ_REQUEST = "MARK_NOTIFICATION_AS_READ_REQUEST";
export const MARK_NOTIFICATION_AS_READ_SUCCESS = "MARK_NOTIFICATION_AS_READ_SUCCESS";
export const MARK_NOTIFICATION_AS_READ_FAILURE = "MARK_NOTIFICATION_AS_READ_FAILURE";

export const FETCH_ALL_NOTIFICATIONS_REQUEST = "FETCH_ALL_NOTIFICATIONS_REQUEST";
export const FETCH_ALL_NOTIFICATIONS_SUCCESS = "FETCH_ALL_NOTIFICATIONS_SUCCESS";
export const FETCH_ALL_NOTIFICATIONS_FAILURE = "FETCH_ALL_NOTIFICATIONS_FAILURE";

export const SEND_NOTIFICATION_REQUEST = "SEND_NOTIFICATION_REQUEST";
export const SEND_NOTIFICATION_SUCCESS = "SEND_NOTIFICATION_SUCCESS";
export const SEND_NOTIFICATION_FAILURE = "SEND_NOTIFICATION_FAILURE";

export const SEND_BROADCAST_NOTIFICATION_REQUEST = "SEND_BROADCAST_NOTIFICATION_REQUEST";
export const SEND_BROADCAST_NOTIFICATION_SUCCESS = "SEND_BROADCAST_NOTIFICATION_SUCCESS";
export const SEND_BROADCAST_NOTIFICATION_FAILURE = "SEND_BROADCAST_NOTIFICATION_FAILURE";


//Reports
export const FETCH_TOTAL_COUNT_REQUEST = "FETCH_TOTAL_COUNT_REQUEST";
export const FETCH_TOTAL_COUNT_SUCCESS = "FETCH_TOTAL_COUNT_SUCCESS";
export const FETCH_TOTAL_COUNT_FAILURE = "FETCH_TOTAL_COUNT_FAILURE";

export const FETCH_TOTAL_REVENUE_REQUEST = "FETCH_TOTAL_REVENUE_REQUEST";
export const FETCH_TOTAL_REVENUE_SUCCESS = "FETCH_TOTAL_REVENUE_SUCCESS";
export const FETCH_TOTAL_REVENUE_FAILURE = "FETCH_TOTAL_REVENUE_FAILURE";

export const FETCH_DATA_BY_DATE_REQUEST = "FETCH_DATA_BY_DATE_REQUEST";
export const FETCH_DATA_BY_DATE_SUCCESS = "FETCH_DATA_BY_DATE_SUCCESS";
export const FETCH_DATA_BY_DATE_FAILURE = "FETCH_DATA_BY_DATE_FAILURE";

export const FETCH_STATUS_DISTRIBUTION_REQUEST = "FETCH_STATUS_DISTRIBUTION_REQUEST";
export const FETCH_STATUS_DISTRIBUTION_SUCCESS = "FETCH_STATUS_DISTRIBUTION_SUCCESS";
export const FETCH_STATUS_DISTRIBUTION_FAILURE = "FETCH_STATUS_DISTRIBUTION_FAILURE";

export const FETCH_TOP_DRIVERS_REQUEST = "FETCH_TOP_DRIVERS_REQUEST";
export const FETCH_TOP_DRIVERS_SUCCESS = "FETCH_TOP_DRIVERS_SUCCESS";
export const FETCH_TOP_DRIVERS_FAILURE = "FETCH_TOP_DRIVERS_FAILURE";

export const FETCH_DISTRICT_REPORTS_REQUEST = "FETCH_DISTRICT_REPORTS_REQUEST";
export const FETCH_DISTRICT_REPORTS_SUCCESS = "FETCH_DISTRICT_REPORTS_SUCCESS";
export const FETCH_DISTRICT_REPORTS_FAILURE = "FETCH_DISTRICT_REPORTS_FAILURE";

export const FETCH_TOP_USERS_BY_SPENDING_REQUEST = "FETCH_TOP_USERS_BY_SPENDING_REQUEST";
export const FETCH_TOP_USERS_BY_SPENDING_SUCCESS = "FETCH_TOP_USERS_BY_SPENDING_SUCCESS";
export const FETCH_TOP_USERS_BY_SPENDING_FAILURE = "FETCH_TOP_USERS_BY_SPENDING_FAILURE";

export const FETCH_TOP_USERS_BY_PACKAGES_REQUEST = "FETCH_TOP_USERS_BY_PACKAGES_REQUEST";
export const FETCH_TOP_USERS_BY_PACKAGES_SUCCESS = "FETCH_TOP_USERS_BY_PACKAGES_SUCCESS";
export const FETCH_TOP_USERS_BY_PACKAGES_FAILURE = "FETCH_TOP_USERS_BY_PACKAGES_FAILURE";

export const FETCH_RECENT_TRANSACTIONS_REQUEST = "FETCH_RECENT_TRANSACTIONS_REQUEST";
export const FETCH_RECENT_TRANSACTIONS_SUCCESS = "FETCH_RECENT_TRANSACTIONS_SUCCESS";
export const FETCH_RECENT_TRANSACTIONS_FAILURE = "FETCH_RECENT_TRANSACTIONS_FAILURE";

// Commission Action Types
export const FETCH_COMMISSIONS_REQUEST = "FETCH_COMMISSIONS_REQUEST";
export const FETCH_COMMISSIONS_SUCCESS = "FETCH_COMMISSIONS_SUCCESS";
export const FETCH_COMMISSIONS_FAILURE = "FETCH_COMMISSIONS_FAILURE";

export const ADD_COMMISSION_REQUEST = "ADD_COMMISSION_REQUEST";
export const ADD_COMMISSION_SUCCESS = "ADD_COMMISSION_SUCCESS";
export const ADD_COMMISSION_FAILURE = "ADD_COMMISSION_FAILURE";

export const UPDATE_COMMISSION_REQUEST = "UPDATE_COMMISSION_REQUEST";
export const UPDATE_COMMISSION_SUCCESS = "UPDATE_COMMISSION_SUCCESS";
export const UPDATE_COMMISSION_FAILURE = "UPDATE_COMMISSION_FAILURE";

export const DELETE_COMMISSION_REQUEST = "DELETE_COMMISSION_REQUEST";
export const DELETE_COMMISSION_SUCCESS = "DELETE_COMMISSION_SUCCESS";
export const DELETE_COMMISSION_FAILURE = "DELETE_COMMISSION_FAILURE";

// Fetch Policies
export const FETCH_POLICIES_REQUEST = 'FETCH_POLICIES_REQUEST';
export const FETCH_POLICIES_SUCCESS = 'FETCH_POLICIES_SUCCESS';
export const FETCH_POLICIES_FAILURE = 'FETCH_POLICIES_FAILURE';

// Add Policy
export const ADD_POLICY_REQUEST = 'ADD_POLICY_REQUEST';
export const ADD_POLICY_SUCCESS = 'ADD_POLICY_SUCCESS';
export const ADD_POLICY_FAILURE = 'ADD_POLICY_FAILURE';

// Update Policy
export const UPDATE_POLICY_REQUEST = 'UPDATE_POLICY_REQUEST';
export const UPDATE_POLICY_SUCCESS = 'UPDATE_POLICY_SUCCESS';
export const UPDATE_POLICY_FAILURE = 'UPDATE_POLICY_FAILURE';

// Delete Policy
export const DELETE_POLICY_REQUEST = 'DELETE_POLICY_REQUEST';
export const DELETE_POLICY_SUCCESS = 'DELETE_POLICY_SUCCESS';
export const DELETE_POLICY_FAILURE = 'DELETE_POLICY_FAILURE';

// Action Types for Contact Support Messages
export const FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST = "FETCH_CONTACT_SUPPORT_MESSAGES_REQUEST";
export const FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS = "FETCH_CONTACT_SUPPORT_MESSAGES_SUCCESS";
export const FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE = "FETCH_CONTACT_SUPPORT_MESSAGES_FAILURE";

export const UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST = "UPDATE_CONTACT_SUPPORT_MESSAGE_REQUEST";
export const UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS = "UPDATE_CONTACT_SUPPORT_MESSAGE_SUCCESS";
export const UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE = "UPDATE_CONTACT_SUPPORT_MESSAGE_FAILURE";

// Vehicle action types
export const FETCH_VEHICLES_REQUEST = "FETCH_VEHICLES_REQUEST";
export const FETCH_VEHICLES_SUCCESS = "FETCH_VEHICLES_SUCCESS";
export const FETCH_VEHICLES_FAILURE = "FETCH_VEHICLES_FAILURE";

export const UPDATE_VEHICLE_STATUS_REQUEST = "UPDATE_VEHICLE_STATUS_REQUEST";
export const UPDATE_VEHICLE_STATUS_SUCCESS = "UPDATE_VEHICLE_STATUS_SUCCESS";
export const UPDATE_VEHICLE_STATUS_FAILURE = "UPDATE_VEHICLE_STATUS_FAILURE";

// Business action types
export const FETCH_BUSINESSES_REQUEST = 'FETCH_BUSINESSES_REQUEST';
export const FETCH_BUSINESSES_SUCCESS = 'FETCH_BUSINESSES_SUCCESS';
export const FETCH_BUSINESSES_FAILURE = 'FETCH_BUSINESSES_FAILURE';

export const UPDATE_BUSINESS_STATUS_REQUEST = 'UPDATE_BUSINESS_STATUS_REQUEST';
export const UPDATE_BUSINESS_STATUS_SUCCESS = 'UPDATE_BUSINESS_STATUS_SUCCESS';
export const UPDATE_BUSINESS_STATUS_FAILURE = 'UPDATE_BUSINESS_STATUS_FAILURE';

// Driver action types
export const FETCH_DRIVERS_REQUEST = 'FETCH_DRIVERS_REQUEST';
export const FETCH_DRIVERS_SUCCESS = 'FETCH_DRIVERS_SUCCESS';
export const FETCH_DRIVERS_FAILURE = 'FETCH_DRIVERS_FAILURE';

export const UPDATE_DRIVER_STATUS_REQUEST = 'UPDATE_DRIVER_STATUS_REQUEST';
export const UPDATE_DRIVER_STATUS_SUCCESS = 'UPDATE_DRIVER_STATUS_SUCCESS';
export const UPDATE_DRIVER_STATUS_FAILURE = 'UPDATE_DRIVER_STATUS_FAILURE';

// fetch privacy settings
export const FETCH_PRIVACY_SETTINGS_REQUEST = "FETCH_PRIVACY_SETTINGS_REQUEST";
export const FETCH_PRIVACY_SETTINGS_SUCCESS = "FETCH_PRIVACY_SETTINGS_SUCCESS";
export const FETCH_PRIVACY_SETTINGS_FAILURE = "FETCH_PRIVACY_SETTINGS_FAILURE";

//bank details
export const FETCH_BANK_DETAILS_REQUEST = "FETCH_BANK_DETAILS_REQUEST";
export const FETCH_BANK_DETAILS_SUCCESS = "FETCH_BANK_DETAILS_SUCCESS";
export const FETCH_BANK_DETAILS_FAILURE = "FETCH_BANK_DETAILS_FAILURE";

export const CREATE_BANK_DETAILS_REQUEST = "CREATE_BANK_DETAILS_REQUEST";
export const CREATE_BANK_DETAILS_SUCCESS = "CREATE_BANK_DETAILS_SUCCESS";
export const CREATE_BANK_DETAILS_FAILURE = "CREATE_BANK_DETAILS_FAILURE";

export const UPDATE_BANK_DETAILS_REQUEST = "UPDATE_BANK_DETAILS_REQUEST";
export const UPDATE_BANK_DETAILS_SUCCESS = "UPDATE_BANK_DETAILS_SUCCESS";
export const UPDATE_BANK_DETAILS_FAILURE = "UPDATE_BANK_DETAILS_FAILURE";

export const DELETE_BANK_DETAILS_REQUEST = "DELETE_BANK_DETAILS_REQUEST";
export const DELETE_BANK_DETAILS_SUCCESS = "DELETE_BANK_DETAILS_SUCCESS";
export const DELETE_BANK_DETAILS_FAILURE = "DELETE_BANK_DETAILS_FAILURE";

export const FETCH_PLANS_REQUEST = "FETCH_PLANS_REQUEST";
export const FETCH_PLANS_SUCCESS = "FETCH_PLANS_SUCCESS";
export const FETCH_PLANS_FAILURE = "FETCH_PLANS_FAILURE";

export const CREATE_PLAN_REQUEST = "CREATE_PLAN_REQUEST";
export const CREATE_PLAN_SUCCESS = "CREATE_PLAN_SUCCESS";
export const CREATE_PLAN_FAILURE = "CREATE_PLAN_FAILURE";

export const UPDATE_PLAN_REQUEST = "UPDATE_PLAN_REQUEST";
export const UPDATE_PLAN_SUCCESS = "UPDATE_PLAN_SUCCESS";
export const UPDATE_PLAN_FAILURE = "UPDATE_PLAN_FAILURE";

export const DELETE_PLAN_REQUEST = "DELETE_PLAN_REQUEST";
export const DELETE_PLAN_SUCCESS = "DELETE_PLAN_SUCCESS";
export const DELETE_PLAN_FAILURE = "DELETE_PLAN_FAILURE";

export const ALLOCATE_DRIVER_PLAN_REQUEST = "ALLOCATE_DRIVER_PLAN_REQUEST";
export const ALLOCATE_DRIVER_PLAN_SUCCESS = "ALLOCATE_DRIVER_PLAN_SUCCESS";
export const ALLOCATE_DRIVER_PLAN_FAILURE = "ALLOCATE_DRIVER_PLAN_FAILURE";

//rates
export const FETCH_RATES_REQUEST = "FETCH_RATES_REQUEST";
export const FETCH_RATES_SUCCESS = "FETCH_RATES_SUCCESS";
export const FETCH_RATES_FAILURE = "FETCH_RATES_FAILURE";

export const CREATE_RATE_REQUEST = "CREATE_RATE_REQUEST";
export const CREATE_RATE_SUCCESS = "CREATE_RATE_SUCCESS";
export const CREATE_RATE_FAILURE = "CREATE_RATE_FAILURE";

export const UPDATE_RATE_REQUEST = "UPDATE_RATE_REQUEST";
export const UPDATE_RATE_SUCCESS = "UPDATE_RATE_SUCCESS";
export const UPDATE_RATE_FAILURE = "UPDATE_RATE_FAILURE";

export const DELETE_RATE_REQUEST = "DELETE_RATE_REQUEST";
export const DELETE_RATE_SUCCESS = "DELETE_RATE_SUCCESS";
export const DELETE_RATE_FAILURE = "DELETE_RATE_FAILURE";

// Fetch Payment Proofs
export const FETCH_PAYMENT_PROOFS_REQUEST = "FETCH_PAYMENT_PROOFS_REQUEST";
export const FETCH_PAYMENT_PROOFS_SUCCESS = "FETCH_PAYMENT_PROOFS_SUCCESS";
export const FETCH_PAYMENT_PROOFS_FAILURE = "FETCH_PAYMENT_PROOFS_FAILURE";

export const UPDATE_PAYMENT_PROOF_STATUS_REQUEST = "UPDATE_PAYMENT_PROOF_STATUS_REQUEST";
export const UPDATE_PAYMENT_PROOF_STATUS_SUCCESS = "UPDATE_PAYMENT_PROOF_STATUS_SUCCESS";
export const UPDATE_PAYMENT_PROOF_STATUS_FAILURE = "UPDATE_PAYMENT_PROOF_STATUS_FAILURE";

//company settings
export const FETCH_COMPANY_SETTINGS_REQUEST = "FETCH_COMPANY_SETTINGS_REQUEST";
export const FETCH_COMPANY_SETTINGS_SUCCESS = "FETCH_COMPANY_SETTINGS_SUCCESS";
export const FETCH_COMPANY_SETTINGS_FAILURE = "FETCH_COMPANY_SETTINGS_FAILURE";

export const CREATE_COMPANY_SETTINGS_REQUEST = "CREATE_COMPANY_SETTINGS_REQUEST";
export const CREATE_COMPANY_SETTINGS_SUCCESS = "CREATE_COMPANY_SETTINGS_SUCCESS";
export const CREATE_COMPANY_SETTINGS_FAILURE = "CREATE_COMPANY_SETTINGS_FAILURE";

export const UPDATE_COMPANY_SETTINGS_REQUEST = "UPDATE_COMPANY_SETTINGS_REQUEST";
export const UPDATE_COMPANY_SETTINGS_SUCCESS = "UPDATE_COMPANY_SETTINGS_SUCCESS";
export const UPDATE_COMPANY_SETTINGS_FAILURE = "UPDATE_COMPANY_SETTINGS_FAILURE";

export const DELETE_COMPANY_SETTINGS_REQUEST = "DELETE_COMPANY_SETTINGS_REQUEST";
export const DELETE_COMPANY_SETTINGS_SUCCESS = "DELETE_COMPANY_SETTINGS_SUCCESS";
export const DELETE_COMPANY_SETTINGS_FAILURE = "DELETE_COMPANY_SETTINGS_FAILURE";

// Protection Tiers
export const FETCH_PROTECTION_TIERS_REQUEST = "FETCH_PROTECTION_TIERS_REQUEST";
export const FETCH_PROTECTION_TIERS_SUCCESS = "FETCH_PROTECTION_TIERS_SUCCESS";
export const FETCH_PROTECTION_TIERS_FAILURE = "FETCH_PROTECTION_TIERS_FAILURE";

export const CREATE_PROTECTION_TIER_REQUEST = "CREATE_PROTECTION_TIER_REQUEST";
export const CREATE_PROTECTION_TIER_SUCCESS = "CREATE_PROTECTION_TIER_SUCCESS";
export const CREATE_PROTECTION_TIER_FAILURE = "CREATE_PROTECTION_TIER_FAILURE";

export const UPDATE_PROTECTION_TIER_REQUEST = "UPDATE_PROTECTION_TIER_REQUEST";
export const UPDATE_PROTECTION_TIER_SUCCESS = "UPDATE_PROTECTION_TIER_SUCCESS";
export const UPDATE_PROTECTION_TIER_FAILURE = "UPDATE_PROTECTION_TIER_FAILURE";

export const DELETE_PROTECTION_TIER_REQUEST = "DELETE_PROTECTION_TIER_REQUEST";
export const DELETE_PROTECTION_TIER_SUCCESS = "DELETE_PROTECTION_TIER_SUCCESS";
export const DELETE_PROTECTION_TIER_FAILURE = "DELETE_PROTECTION_TIER_FAILURE";

// Claim Form Activation
export const SET_CLAIM_FORM_ACTIVATION_REQUEST = "SET_CLAIM_FORM_ACTIVATION_REQUEST";
export const SET_CLAIM_FORM_ACTIVATION_SUCCESS = "SET_CLAIM_FORM_ACTIVATION_SUCCESS";
export const SET_CLAIM_FORM_ACTIVATION_FAILURE = "SET_CLAIM_FORM_ACTIVATION_FAILURE";

// Claims - fetch all
export const FETCH_CLAIMS_REQUEST = "FETCH_CLAIMS_REQUEST";
export const FETCH_CLAIMS_SUCCESS = "FETCH_CLAIMS_SUCCESS";
export const FETCH_CLAIMS_FAILURE = "FETCH_CLAIMS_FAILURE";

// Claims - review
export const REVIEW_CLAIM_REQUEST = "REVIEW_CLAIM_REQUEST";
export const REVIEW_CLAIM_SUCCESS = "REVIEW_CLAIM_SUCCESS";
export const REVIEW_CLAIM_FAILURE = "REVIEW_CLAIM_FAILURE";

export const FETCH_CLAIMS_SUMMARY_REQUEST = "FETCH_CLAIMS_SUMMARY_REQUEST";
export const FETCH_CLAIMS_SUMMARY_SUCCESS = "FETCH_CLAIMS_SUMMARY_SUCCESS";
export const FETCH_CLAIMS_SUMMARY_FAILURE = "FETCH_CLAIMS_SUMMARY_FAILURE";

//App Version
export const CREATE_APP_VERSION_REQUEST = "CREATE_APP_VERSION_REQUEST";
export const CREATE_APP_VERSION_SUCCESS = "CREATE_APP_VERSION_SUCCESS";
export const CREATE_APP_VERSION_FAILURE = "CREATE_APP_VERSION_FAILURE";

export const FETCH_APP_VERSIONS_REQUEST = "FETCH_APP_VERSIONS_REQUEST";
export const FETCH_APP_VERSIONS_SUCCESS = "FETCH_APP_VERSIONS_SUCCESS";
export const FETCH_APP_VERSIONS_FAILURE = "FETCH_APP_VERSIONS_FAILURE";

export const UPDATE_APP_VERSION_REQUEST = "UPDATE_APP_VERSION_REQUEST";
export const UPDATE_APP_VERSION_SUCCESS = "UPDATE_APP_VERSION_SUCCESS";
export const UPDATE_APP_VERSION_FAILURE = "UPDATE_APP_VERSION_FAILURE";

//Status history
export const FETCH_STATUS_HISTORY_REQUEST = "FETCH_STATUS_HISTORY_REQUEST";
export const FETCH_STATUS_HISTORY_SUCCESS = "FETCH_STATUS_HISTORY_SUCCESS";
export const FETCH_STATUS_HISTORY_FAILURE = "FETCH_STATUS_HISTORY_FAILURE";

//resources
export const FETCH_RESOURCES_REQUEST = "FETCH_RESOURCES_REQUEST";
export const FETCH_RESOURCES_SUCCESS = "FETCH_RESOURCES_SUCCESS";
export const FETCH_RESOURCES_FAILURE = "FETCH_RESOURCES_FAILURE";

export const CREATE_RESOURCE_REQUEST = "CREATE_RESOURCE_REQUEST";
export const CREATE_RESOURCE_SUCCESS = "CREATE_RESOURCE_SUCCESS";
export const CREATE_RESOURCE_FAILURE = "CREATE_RESOURCE_FAILURE";

export const UPDATE_RESOURCE_REQUEST = "UPDATE_RESOURCE_REQUEST";
export const UPDATE_RESOURCE_SUCCESS = "UPDATE_RESOURCE_SUCCESS";
export const UPDATE_RESOURCE_FAILURE = "UPDATE_RESOURCE_FAILURE";

export const DELETE_RESOURCE_REQUEST = "DELETE_RESOURCE_REQUEST";
export const DELETE_RESOURCE_SUCCESS = "DELETE_RESOURCE_SUCCESS";
export const DELETE_RESOURCE_FAILURE = "DELETE_RESOURCE_FAILURE";

//loyalty config
export const FETCH_LOYALTY_CONFIG_REQUEST = "FETCH_LOYALTY_CONFIG_REQUEST";
export const FETCH_LOYALTY_CONFIG_SUCCESS = "FETCH_LOYALTY_CONFIG_SUCCESS";
export const FETCH_LOYALTY_CONFIG_FAILURE = "FETCH_LOYALTY_CONFIG_FAILURE";

export const CREATE_LOYALTY_CONFIG_REQUEST = "CREATE_LOYALTY_CONFIG_REQUEST";
export const CREATE_LOYALTY_CONFIG_SUCCESS = "CREATE_LOYALTY_CONFIG_SUCCESS";
export const CREATE_LOYALTY_CONFIG_FAILURE = "CREATE_LOYALTY_CONFIG_FAILURE";

export const UPDATE_LOYALTY_CONFIG_REQUEST = "UPDATE_LOYALTY_CONFIG_REQUEST";
export const UPDATE_LOYALTY_CONFIG_SUCCESS = "UPDATE_LOYALTY_CONFIG_SUCCESS";
export const UPDATE_LOYALTY_CONFIG_FAILURE = "UPDATE_LOYALTY_CONFIG_FAILURE";

export const DELETE_LOYALTY_CONFIG_REQUEST = "DELETE_LOYALTY_CONFIG_REQUEST";
export const DELETE_LOYALTY_CONFIG_SUCCESS = "DELETE_LOYALTY_CONFIG_SUCCESS";
export const DELETE_LOYALTY_CONFIG_FAILURE = "DELETE_LOYALTY_CONFIG_FAILURE";

//cashouts
export const FETCH_CASHOUTS_REQUEST = "FETCH_CASHOUTS_REQUEST";
export const FETCH_CASHOUTS_SUCCESS = "FETCH_CASHOUTS_SUCCESS";
export const FETCH_CASHOUTS_FAILURE = "FETCH_CASHOUTS_FAILURE";

export const UPDATE_CASHOUT_REQUEST = "UPDATE_CASHOUT_REQUEST";
export const UPDATE_CASHOUT_SUCCESS = "UPDATE_CASHOUT_SUCCESS";
export const UPDATE_CASHOUT_FAILURE = "UPDATE_CASHOUT_FAILURE";

export const FETCH_REFERRALS_REQUEST = "FETCH_REFERRALS_REQUEST";
export const FETCH_REFERRALS_SUCCESS = "FETCH_REFERRALS_SUCCESS";
export const FETCH_REFERRALS_FAILURE = "FETCH_REFERRALS_FAILURE";

//Merchants
export const FETCH_MERCHANTS_REQUEST = "FETCH_MERCHANTS_REQUEST";
export const FETCH_MERCHANTS_SUCCESS = "FETCH_MERCHANTS_SUCCESS";
export const FETCH_MERCHANTS_FAILURE = "FETCH_MERCHANTS_FAILURE";

export const UPDATE_MERCHANT_STATUS_REQUEST =
  "UPDATE_MERCHANT_STATUS_REQUEST";
export const UPDATE_MERCHANT_STATUS_SUCCESS =
  "UPDATE_MERCHANT_STATUS_SUCCESS";
export const UPDATE_MERCHANT_STATUS_FAILURE =
  "UPDATE_MERCHANT_STATUS_FAILURE";

//create product
export const CREATE_PRODUCT_REQUEST = "CREATE_PRODUCT_REQUEST";
export const CREATE_PRODUCT_SUCCESS = "CREATE_PRODUCT_SUCCESS";
export const CREATE_PRODUCT_FAILURE = "CREATE_PRODUCT_FAILURE";
export const FETCH_PRODUCTS_REQUEST = "FETCH_PRODUCTS_REQUEST";
export const FETCH_PRODUCTS_SUCCESS = "FETCH_PRODUCTS_SUCCESS";
export const FETCH_PRODUCTS_FAILURE = "FETCH_PRODUCTS_FAILURE";
export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE";
export const DELETE_PRODUCT_REQUEST = "DELETE_PRODUCT_REQUEST";
export const DELETE_PRODUCT_SUCCESS = "DELETE_PRODUCT_SUCCESS";
export const DELETE_PRODUCT_FAILURE = "DELETE_PRODUCT_FAILURE";

export const MERCHANT_LOGIN_REQUEST = "MERCHANT_LOGIN_REQUEST";
export const MERCHANT_LOGIN_SUCCESS = "MERCHANT_LOGIN_SUCCESS";
export const MERCHANT_LOGIN_FAILURE = "MERCHANT_LOGIN_FAILURE";

// product listings
export const CREATE_LISTING_REQUEST = "CREATE_LISTING_REQUEST";
export const CREATE_LISTING_SUCCESS = "CREATE_LISTING_SUCCESS";
export const CREATE_LISTING_FAILURE = "CREATE_LISTING_FAILURE";

export const FETCH_LISTINGS_REQUEST = "FETCH_LISTINGS_REQUEST";
export const FETCH_LISTINGS_SUCCESS = "FETCH_LISTINGS_SUCCESS";
export const FETCH_LISTINGS_FAILURE = "FETCH_LISTINGS_FAILURE";

export const UPDATE_LISTING_REQUEST = "UPDATE_LISTING_REQUEST";
export const UPDATE_LISTING_SUCCESS = "UPDATE_LISTING_SUCCESS";
export const UPDATE_LISTING_FAILURE = "UPDATE_LISTING_FAILURE";

export const DELETE_LISTING_REQUEST = "DELETE_LISTING_REQUEST";
export const DELETE_LISTING_SUCCESS = "DELETE_LISTING_SUCCESS";
export const DELETE_LISTING_FAILURE = "DELETE_LISTING_FAILURE";

//contact logs
export const CREATE_CONTACT_LOG_REQUEST = "CREATE_CONTACT_LOG_REQUEST";
export const CREATE_CONTACT_LOG_SUCCESS = "CREATE_CONTACT_LOG_SUCCESS";
export const CREATE_CONTACT_LOG_FAILURE = "CREATE_CONTACT_LOG_FAILURE";

export const FETCH_CONTACT_LOGS_REQUEST = "FETCH_CONTACT_LOGS_REQUEST";
export const FETCH_CONTACT_LOGS_SUCCESS = "FETCH_CONTACT_LOGS_SUCCESS";
export const FETCH_CONTACT_LOGS_FAILURE = "FETCH_CONTACT_LOGS_FAILURE";

export const FETCH_USER_CONTACT_LOGS_REQUEST = "FETCH_USER_CONTACT_LOGS_REQUEST";
export const FETCH_USER_CONTACT_LOGS_SUCCESS = "FETCH_USER_CONTACT_LOGS_SUCCESS";
export const FETCH_USER_CONTACT_LOGS_FAILURE = "FETCH_USER_CONTACT_LOGS_FAILURE";

export const UPDATE_CONTACT_LOG_REQUEST = "UPDATE_CONTACT_LOG_REQUEST";
export const UPDATE_CONTACT_LOG_SUCCESS = "UPDATE_CONTACT_LOG_SUCCESS";
export const UPDATE_CONTACT_LOG_FAILURE = "UPDATE_CONTACT_LOG_FAILURE";

export const DELETE_CONTACT_LOG_REQUEST = "DELETE_CONTACT_LOG_REQUEST";
export const DELETE_CONTACT_LOG_SUCCESS = "DELETE_CONTACT_LOG_SUCCESS";
export const DELETE_CONTACT_LOG_FAILURE = "DELETE_CONTACT_LOG_FAILURE";

//order
export const FETCH_MERCHANT_ORDERS_REQUEST = "FETCH_MERCHANT_ORDERS_REQUEST";
export const FETCH_MERCHANT_ORDERS_SUCCESS = "FETCH_MERCHANT_ORDERS_SUCCESS";
export const FETCH_MERCHANT_ORDERS_FAILURE = "FETCH_MERCHANT_ORDERS_FAILURE";

export const MAKE_ORDER_READY_REQUEST = "MAKE_ORDER_READY_REQUEST";
export const MAKE_ORDER_READY_SUCCESS = "MAKE_ORDER_READY_SUCCESS";
export const MAKE_ORDER_READY_FAILURE = "MAKE_ORDER_READY_FAILURE";

export const UPDATE_ORDER_STATUS_REQUEST = "UPDATE_ORDER_STATUS_REQUEST";
export const UPDATE_ORDER_STATUS_SUCCESS = "UPDATE_ORDER_STATUS_SUCCESS";
export const UPDATE_ORDER_STATUS_FAILURE = "UPDATE_ORDER_STATUS_FAILURE";

//package price
export const CALCULATE_PACKAGE_PRICE_REQUEST =
  "CALCULATE_PACKAGE_PRICE_REQUEST";
export const CALCULATE_PACKAGE_PRICE_SUCCESS =
  "CALCULATE_PACKAGE_PRICE_SUCCESS";
export const CALCULATE_PACKAGE_PRICE_FAILURE =
  "CALCULATE_PACKAGE_PRICE_FAILURE";

//protection quote
export const FETCH_PROTECTION_QUOTE_REQUEST =
  "FETCH_PROTECTION_QUOTE_REQUEST";
export const FETCH_PROTECTION_QUOTE_SUCCESS =
  "FETCH_PROTECTION_QUOTE_SUCCESS";
export const FETCH_PROTECTION_QUOTE_FAILURE =
  "FETCH_PROTECTION_QUOTE_FAILURE";

//reports
export const FETCH_REPORT_REQUEST = "FETCH_REPORT_REQUEST";
export const FETCH_REPORT_SUCCESS = "FETCH_REPORT_SUCCESS";
export const FETCH_REPORT_FAILURE = "FETCH_REPORT_FAILURE";

//partner actions
export const FETCH_PARTNERS_REQUEST = "FETCH_PARTNERS_REQUEST";
export const FETCH_PARTNERS_SUCCESS = "FETCH_PARTNERS_SUCCESS";
export const FETCH_PARTNERS_FAILURE = "FETCH_PARTNERS_FAILURE";

export const CREATE_PARTNER_REQUEST = "CREATE_PARTNER_REQUEST";
export const CREATE_PARTNER_SUCCESS = "CREATE_PARTNER_SUCCESS";
export const CREATE_PARTNER_FAILURE = "CREATE_PARTNER_FAILURE";

export const UPDATE_PARTNER_REQUEST = "UPDATE_PARTNER_REQUEST";
export const UPDATE_PARTNER_SUCCESS = "UPDATE_PARTNER_SUCCESS";
export const UPDATE_PARTNER_FAILURE = "UPDATE_PARTNER_FAILURE";

export const DELETE_PARTNER_REQUEST = "DELETE_PARTNER_REQUEST";
export const DELETE_PARTNER_SUCCESS = "DELETE_PARTNER_SUCCESS";
export const DELETE_PARTNER_FAILURE = "DELETE_PARTNER_FAILURE";

export const FETCH_PARTNER_SUBSCRIPTIONS_REQUEST = "FETCH_PARTNER_SUBSCRIPTIONS_REQUEST";
export const FETCH_PARTNER_SUBSCRIPTIONS_SUCCESS = "FETCH_PARTNER_SUBSCRIPTIONS_SUCCESS";
export const FETCH_PARTNER_SUBSCRIPTIONS_FAILURE = "FETCH_PARTNER_SUBSCRIPTIONS_FAILURE";

//Delivery API Plans
export const FETCH_PARTNER_PLANS_REQUEST = "FETCH_PARTNER_PLANS_REQUEST";
export const FETCH_PARTNER_PLANS_SUCCESS = "FETCH_PARTNER_PLANS_SUCCESS";
export const FETCH_PARTNER_PLANS_FAILURE = "FETCH_PARTNER_PLANS_FAILURE";

export const CREATE_PARTNER_PLAN_REQUEST = "CREATE_PARTNER_PLAN_REQUEST";
export const CREATE_PARTNER_PLAN_SUCCESS = "CREATE_PARTNER_PLAN_SUCCESS";
export const CREATE_PARTNER_PLAN_FAILURE = "CREATE_PARTNER_PLAN_FAILURE";

export const UPDATE_PARTNER_PLAN_REQUEST = "UPDATE_PARTNER_PLAN_REQUEST";
export const UPDATE_PARTNER_PLAN_SUCCESS = "UPDATE_PARTNER_PLAN_SUCCESS";
export const UPDATE_PARTNER_PLAN_FAILURE = "UPDATE_PARTNER_PLAN_FAILURE";

export const DELETE_PARTNER_PLAN_REQUEST = "DELETE_PARTNER_PLAN_REQUEST";
export const DELETE_PARTNER_PLAN_SUCCESS = "DELETE_PARTNER_PLAN_SUCCESS";
export const DELETE_PARTNER_PLAN_FAILURE = "DELETE_PARTNER_PLAN_FAILURE";

//DRIVER PARTNER ACTIONS
export const FETCH_DRIVER_PARTNERS_REQUEST ="FETCH_DRIVER_PARTNERS_REQUEST";
export const FETCH_DRIVER_PARTNERS_SUCCESS ="FETCH_DRIVER_PARTNERS_SUCCESS";
export const FETCH_DRIVER_PARTNERS_FAILURE ="FETCH_DRIVER_PARTNERS_FAILURE";

export const UPDATE_DRIVER_PARTNER_STATUS_REQUEST ="UPDATE_DRIVER_PARTNER_STATUS_REQUEST";
export const UPDATE_DRIVER_PARTNER_STATUS_SUCCESS ="UPDATE_DRIVER_PARTNER_STATUS_SUCCESS";
export const UPDATE_DRIVER_PARTNER_STATUS_FAILURE ="UPDATE_DRIVER_PARTNER_STATUS_FAILURE";

export const FETCH_REFERRED_DRIVERS_REQUEST ="FETCH_REFERRED_DRIVERS_REQUEST";
export const FETCH_REFERRED_DRIVERS_SUCCESS ="FETCH_REFERRED_DRIVERS_SUCCESS";
export const FETCH_REFERRED_DRIVERS_FAILURE ="FETCH_REFERRED_DRIVERS_FAILURE";

//COMMISION RULE FOR DRIVER PARTNERS
// Fetch
export const FETCH_COMMISSION_RULES_REQUEST ="FETCH_COMMISSION_RULES_REQUEST";
export const FETCH_COMMISSION_RULES_SUCCESS ="FETCH_COMMISSION_RULES_SUCCESS";
export const FETCH_COMMISSION_RULES_FAILURE ="FETCH_COMMISSION_RULES_FAILURE";

// Create
export const CREATE_COMMISSION_RULE_REQUEST ="CREATE_COMMISSION_RULE_REQUEST";
export const CREATE_COMMISSION_RULE_SUCCESS ="CREATE_COMMISSION_RULE_SUCCESS";
export const CREATE_COMMISSION_RULE_FAILURE ="CREATE_COMMISSION_RULE_FAILURE";

// Update
export const UPDATE_COMMISSION_RULE_REQUEST ="UPDATE_COMMISSION_RULE_REQUEST";
export const UPDATE_COMMISSION_RULE_SUCCESS ="UPDATE_COMMISSION_RULE_SUCCESS";
export const UPDATE_COMMISSION_RULE_FAILURE ="UPDATE_COMMISSION_RULE_FAILURE";

// Delete
export const DELETE_COMMISSION_RULE_REQUEST ="DELETE_COMMISSION_RULE_REQUEST";
export const DELETE_COMMISSION_RULE_SUCCESS ="DELETE_COMMISSION_RULE_SUCCESS";
export const DELETE_COMMISSION_RULE_FAILURE ="DELETE_COMMISSION_RULE_FAILURE";

//REFERRAL MILESTONES FRO DRIVER
export const FETCH_REFERRAL_MILESTONES_REQUEST ="FETCH_REFERRAL_MILESTONES_REQUEST";
export const FETCH_REFERRAL_MILESTONES_SUCCESS ="FETCH_REFERRAL_MILESTONES_SUCCESS";
export const FETCH_REFERRAL_MILESTONES_FAILURE ="FETCH_REFERRAL_MILESTONES_FAILURE";

//PENDING COMMISION PAYOUT
export const FETCH_PENDING_COMMISSIONS_REQUEST ="FETCH_PENDING_COMMISSIONS_REQUEST";
export const FETCH_PENDING_COMMISSIONS_SUCCESS ="FETCH_PENDING_COMMISSIONS_SUCCESS";
export const FETCH_PENDING_COMMISSIONS_FAILURE ="FETCH_PENDING_COMMISSIONS_FAILURE";

//PAYOUTS COMMISSION
export const FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST ="FETCH_DRIVER_PARTNER_PAYOUTS_REQUEST";
export const FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS ="FETCH_DRIVER_PARTNER_PAYOUTS_SUCCESS";
export const FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE ="FETCH_DRIVER_PARTNER_PAYOUTS_FAILURE";

export const CREATE_DRIVER_PARTNER_PAYOUT_REQUEST ="CREATE_DRIVER_PARTNER_PAYOUT_REQUEST";
export const CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS ="CREATE_DRIVER_PARTNER_PAYOUT_SUCCESS";
export const CREATE_DRIVER_PARTNER_PAYOUT_FAILURE ="CREATE_DRIVER_PARTNER_PAYOUT_FAILURE";

//SUPPPORT TICKETS FOR DRIVER PARTNERS
export const FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST ="FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_REQUEST";
export const FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS ="FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_SUCCESS";
export const FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE ="FETCH_DRIVER_PARTNER_SUPPORT_TICKETS_FAILURE";

export const UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST ="UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_REQUEST";
export const UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS ="UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_SUCCESS";
export const UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE ="UPDATE_DRIVER_PARTNER_SUPPORT_TICKET_FAILURE";

// Fetch Agent Support Tickets
export const FETCH_AGENT_SUPPORT_TICKETS_REQUEST ="FETCH_AGENT_SUPPORT_TICKETS_REQUEST";
export const FETCH_AGENT_SUPPORT_TICKETS_SUCCESS ="FETCH_AGENT_SUPPORT_TICKETS_SUCCESS";
export const FETCH_AGENT_SUPPORT_TICKETS_FAILURE ="FETCH_AGENT_SUPPORT_TICKETS_FAILURE";

// Update Agent Support Ticket
export const UPDATE_AGENT_SUPPORT_TICKET_REQUEST ="UPDATE_AGENT_SUPPORT_TICKET_REQUEST";
export const UPDATE_AGENT_SUPPORT_TICKET_SUCCESS ="UPDATE_AGENT_SUPPORT_TICKET_SUCCESS";
export const UPDATE_AGENT_SUPPORT_TICKET_FAILURE ="UPDATE_AGENT_SUPPORT_TICKET_FAILURE";

//DRIVER PARTNER ANALYTICS
export const DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST ="DRIVER_PARTNER_ANALYTICS_SUMMARY_REQUEST";
export const DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS ="DRIVER_PARTNER_ANALYTICS_SUMMARY_SUCCESS";
export const DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL ="DRIVER_PARTNER_ANALYTICS_SUMMARY_FAIL";

export const DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST ="DRIVER_PARTNER_PARTNER_PERFORMANCE_REQUEST";
export const DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS ="DRIVER_PARTNER_PARTNER_PERFORMANCE_SUCCESS";
export const DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL ="DRIVER_PARTNER_PARTNER_PERFORMANCE_FAIL";

export const DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST ="DRIVER_PARTNER_COMMISSION_LIABILITY_REQUEST";
export const DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS ="DRIVER_PARTNER_COMMISSION_LIABILITY_SUCCESS";
export const DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL ="DRIVER_PARTNER_COMMISSION_LIABILITY_FAIL";

export const DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST ="DRIVER_PARTNER_PAID_COMMISSIONS_REQUEST";
export const DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS ="DRIVER_PARTNER_PAID_COMMISSIONS_SUCCESS";
export const DRIVER_PARTNER_PAID_COMMISSIONS_FAIL ="DRIVER_PARTNER_PAID_COMMISSIONS_FAIL";

export const DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST ="DRIVER_PARTNER_SUSPICIOUS_REFERRALS_REQUEST";
export const DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS ="DRIVER_PARTNER_SUSPICIOUS_REFERRALS_SUCCESS";
export const DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL ="DRIVER_PARTNER_SUSPICIOUS_REFERRALS_FAIL";

export const DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST ="DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_REQUEST";
export const DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS ="DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_SUCCESS";
export const DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL ="DRIVER_PARTNER_REFERRED_DRIVER_LOCATIONS_FAIL";

export const DRIVER_PARTNER_TOP_PERFORMING_REQUEST ="DRIVER_PARTNER_TOP_PERFORMING_REQUEST";
export const DRIVER_PARTNER_TOP_PERFORMING_SUCCESS ="DRIVER_PARTNER_TOP_PERFORMING_SUCCESS";
export const DRIVER_PARTNER_TOP_PERFORMING_FAIL ="DRIVER_PARTNER_TOP_PERFORMING_FAIL";

//Wallet admin top up
export const ADMIN_TOP_UP_WALLET_REQUEST ="ADMIN_TOP_UP_WALLET_REQUEST";
export const ADMIN_TOP_UP_WALLET_SUCCESS ="ADMIN_TOP_UP_WALLET_SUCCESS";
export const ADMIN_TOP_UP_WALLET_FAILURE ="ADMIN_TOP_UP_WALLET_FAILURE";

export const FETCH_WALLET_TRANSACTIONS_REQUEST ="FETCH_WALLET_TRANSACTIONS_REQUEST";
export const FETCH_WALLET_TRANSACTIONS_SUCCESS ="FETCH_WALLET_TRANSACTIONS_SUCCESS";
export const FETCH_WALLET_TRANSACTIONS_FAILURE ="FETCH_WALLET_TRANSACTIONS_FAILURE";

export const FETCH_DRIVER_WALLETS_REQUEST ="FETCH_DRIVER_WALLETS_REQUEST";
export const FETCH_DRIVER_WALLETS_SUCCESS ="FETCH_DRIVER_WALLETS_SUCCESS";
export const FETCH_DRIVER_WALLETS_FAILURE ="FETCH_DRIVER_WALLETS_FAILURE";

//agent
export const FETCH_AGENTS_REQUEST ="FETCH_AGENTS_REQUEST";
export const FETCH_AGENTS_SUCCESS ="FETCH_AGENTS_SUCCESS";
export const FETCH_AGENTS_FAILURE ="FETCH_AGENTS_FAILURE";

export const UPDATE_AGENT_STATUS_REQUEST ="UPDATE_AGENT_STATUS_REQUEST";
export const UPDATE_AGENT_STATUS_SUCCESS ="UPDATE_AGENT_STATUS_SUCCESS";
export const UPDATE_AGENT_STATUS_FAILURE ="UPDATE_AGENT_STATUS_FAILURE";

// Starter Kit Components
export const FETCH_STARTER_KIT_COMPONENTS_REQUEST ="FETCH_STARTER_KIT_COMPONENTS_REQUEST";
export const FETCH_STARTER_KIT_COMPONENTS_SUCCESS ="FETCH_STARTER_KIT_COMPONENTS_SUCCESS";
export const FETCH_STARTER_KIT_COMPONENTS_FAILURE ="FETCH_STARTER_KIT_COMPONENTS_FAILURE";

export const CREATE_STARTER_KIT_COMPONENT_REQUEST ="CREATE_STARTER_KIT_COMPONENT_REQUEST";
export const CREATE_STARTER_KIT_COMPONENT_SUCCESS ="CREATE_STARTER_KIT_COMPONENT_SUCCESS";
export const CREATE_STARTER_KIT_COMPONENT_FAILURE ="CREATE_STARTER_KIT_COMPONENT_FAILURE";

export const UPDATE_STARTER_KIT_COMPONENT_REQUEST ="UPDATE_STARTER_KIT_COMPONENT_REQUEST";
export const UPDATE_STARTER_KIT_COMPONENT_SUCCESS ="UPDATE_STARTER_KIT_COMPONENT_SUCCESS";
export const UPDATE_STARTER_KIT_COMPONENT_FAILURE ="UPDATE_STARTER_KIT_COMPONENT_FAILURE";

export const DELETE_STARTER_KIT_COMPONENT_REQUEST ="DELETE_STARTER_KIT_COMPONENT_REQUEST";
export const DELETE_STARTER_KIT_COMPONENT_SUCCESS ="DELETE_STARTER_KIT_COMPONENT_SUCCESS";
export const DELETE_STARTER_KIT_COMPONENT_FAILURE ="DELETE_STARTER_KIT_COMPONENT_FAILURE";

export const FETCH_STARTER_KIT_PURCHASES_REQUEST ="FETCH_STARTER_KIT_PURCHASES_REQUEST";
export const FETCH_STARTER_KIT_PURCHASES_SUCCESS ="FETCH_STARTER_KIT_PURCHASES_SUCCESS";
export const FETCH_STARTER_KIT_PURCHASES_FAILURE ="FETCH_STARTER_KIT_PURCHASES_FAILURE";

export const FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST ="FETCH_STARTER_KIT_PAYMENT_PROOFS_REQUEST";
export const FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS ="FETCH_STARTER_KIT_PAYMENT_PROOFS_SUCCESS";
export const FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE ="FETCH_STARTER_KIT_PAYMENT_PROOFS_FAILURE";

export const UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST ="UPDATE_STARTER_KIT_PAYMENT_PROOF_REQUEST";
export const UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS ="UPDATE_STARTER_KIT_PAYMENT_PROOF_SUCCESS";
export const UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE ="UPDATE_STARTER_KIT_PAYMENT_PROOF_FAILURE";

//Agent Training
export const FETCH_AGENT_TRAINING_REQUEST ="FETCH_AGENT_TRAINING_REQUEST";
export const FETCH_AGENT_TRAINING_SUCCESS ="FETCH_AGENT_TRAINING_SUCCESS";
export const FETCH_AGENT_TRAINING_FAILURE ="FETCH_AGENT_TRAINING_FAILURE";

export const CREATE_AGENT_TRAINING_REQUEST ="CREATE_AGENT_TRAINING_REQUEST";
export const CREATE_AGENT_TRAINING_SUCCESS ="CREATE_AGENT_TRAINING_SUCCESS";
export const CREATE_AGENT_TRAINING_FAILURE ="CREATE_AGENT_TRAINING_FAILURE";

export const UPDATE_AGENT_TRAINING_REQUEST ="UPDATE_AGENT_TRAINING_REQUEST";
export const UPDATE_AGENT_TRAINING_SUCCESS ="UPDATE_AGENT_TRAINING_SUCCESS";
export const UPDATE_AGENT_TRAINING_FAILURE ="UPDATE_AGENT_TRAINING_FAILURE";

export const DELETE_AGENT_TRAINING_REQUEST ="DELETE_AGENT_TRAINING_REQUEST";
export const DELETE_AGENT_TRAINING_SUCCESS ="DELETE_AGENT_TRAINING_SUCCESS";
export const DELETE_AGENT_TRAINING_FAILURE ="DELETE_AGENT_TRAINING_FAILURE";

// AGENT CERTIFICATION ASSESSMENTS
export const FETCH_ASSESSMENTS_REQUEST ="FETCH_ASSESSMENTS_REQUEST";
export const FETCH_ASSESSMENTS_SUCCESS ="FETCH_ASSESSMENTS_SUCCESS";
export const FETCH_ASSESSMENTS_FAILURE ="FETCH_ASSESSMENTS_FAILURE";

export const CREATE_ASSESSMENT_REQUEST ="CREATE_ASSESSMENT_REQUEST";
export const CREATE_ASSESSMENT_SUCCESS ="CREATE_ASSESSMENT_SUCCESS";
export const CREATE_ASSESSMENT_FAILURE ="CREATE_ASSESSMENT_FAILURE";

export const UPDATE_ASSESSMENT_REQUEST ="UPDATE_ASSESSMENT_REQUEST";
export const UPDATE_ASSESSMENT_SUCCESS ="UPDATE_ASSESSMENT_SUCCESS";
export const UPDATE_ASSESSMENT_FAILURE ="UPDATE_ASSESSMENT_FAILURE";

export const DELETE_ASSESSMENT_REQUEST ="DELETE_ASSESSMENT_REQUEST";
export const DELETE_ASSESSMENT_SUCCESS ="DELETE_ASSESSMENT_SUCCESS";
export const DELETE_ASSESSMENT_FAILURE ="DELETE_ASSESSMENT_FAILURE";

//Agent types
export const FETCH_QUESTIONS_REQUEST ="FETCH_QUESTIONS_REQUEST";
export const FETCH_QUESTIONS_SUCCESS ="FETCH_QUESTIONS_SUCCESS";
export const FETCH_QUESTIONS_FAILURE ="FETCH_QUESTIONS_FAILURE";

export const CREATE_QUESTION_REQUEST ="CREATE_QUESTION_REQUEST";
export const CREATE_QUESTION_SUCCESS ="CREATE_QUESTION_SUCCESS";
export const CREATE_QUESTION_FAILURE ="CREATE_QUESTION_FAILURE";

export const UPDATE_QUESTION_REQUEST ="UPDATE_QUESTION_REQUEST";
export const UPDATE_QUESTION_SUCCESS ="UPDATE_QUESTION_SUCCESS";
export const UPDATE_QUESTION_FAILURE ="UPDATE_QUESTION_FAILURE";

export const DELETE_QUESTION_REQUEST ="DELETE_QUESTION_REQUEST";
export const DELETE_QUESTION_SUCCESS ="DELETE_QUESTION_SUCCESS";
export const DELETE_QUESTION_FAILURE ="DELETE_QUESTION_FAILURE";

//Agent Services
export const FETCH_AGENT_SERVICES_REQUEST ="FETCH_AGENT_SERVICES_REQUEST";
export const FETCH_AGENT_SERVICES_SUCCESS ="FETCH_AGENT_SERVICES_SUCCESS";
export const FETCH_AGENT_SERVICES_FAILURE ="FETCH_AGENT_SERVICES_FAILURE";

export const CREATE_AGENT_SERVICE_REQUEST ="CREATE_AGENT_SERVICE_REQUEST";
export const CREATE_AGENT_SERVICE_SUCCESS ="CREATE_AGENT_SERVICE_SUCCESS";
export const CREATE_AGENT_SERVICE_FAILURE ="CREATE_AGENT_SERVICE_FAILURE";

export const UPDATE_AGENT_SERVICE_REQUEST ="UPDATE_AGENT_SERVICE_REQUEST";
export const UPDATE_AGENT_SERVICE_SUCCESS ="UPDATE_AGENT_SERVICE_SUCCESS";
export const UPDATE_AGENT_SERVICE_FAILURE ="UPDATE_AGENT_SERVICE_FAILURE";

export const DELETE_AGENT_SERVICE_REQUEST ="DELETE_AGENT_SERVICE_REQUEST";
export const DELETE_AGENT_SERVICE_SUCCESS ="DELETE_AGENT_SERVICE_SUCCESS";
export const DELETE_AGENT_SERVICE_FAILURE ="DELETE_AGENT_SERVICE_FAILURE";


// Agent Progression
export const FETCH_AGENT_PROGRESSION_REQUEST = "FETCH_AGENT_PROGRESSION_REQUEST";
export const FETCH_AGENT_PROGRESSION_SUCCESS = "FETCH_AGENT_PROGRESSION_SUCCESS";
export const FETCH_AGENT_PROGRESSION_FAILURE = "FETCH_AGENT_PROGRESSION_FAILURE";

export const FETCH_PROGRESSION_CONFIGURATIONS_REQUEST = "FETCH_PROGRESSION_CONFIGURATIONS_REQUEST";
export const FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS = "FETCH_PROGRESSION_CONFIGURATIONS_SUCCESS";
export const FETCH_PROGRESSION_CONFIGURATIONS_FAILURE = "FETCH_PROGRESSION_CONFIGURATIONS_FAILURE";

export const CREATE_PROGRESSION_CONFIGURATION_REQUEST = "CREATE_PROGRESSION_CONFIGURATION_REQUEST";
export const CREATE_PROGRESSION_CONFIGURATION_SUCCESS = "CREATE_PROGRESSION_CONFIGURATION_SUCCESS";
export const CREATE_PROGRESSION_CONFIGURATION_FAILURE = "CREATE_PROGRESSION_CONFIGURATION_FAILURE";

export const UPDATE_PROGRESSION_CONFIGURATION_REQUEST = "UPDATE_PROGRESSION_CONFIGURATION_REQUEST";
export const UPDATE_PROGRESSION_CONFIGURATION_SUCCESS = "UPDATE_PROGRESSION_CONFIGURATION_SUCCESS";
export const UPDATE_PROGRESSION_CONFIGURATION_FAILURE = "UPDATE_PROGRESSION_CONFIGURATION_FAILURE";

export const DELETE_PROGRESSION_CONFIGURATION_REQUEST = "DELETE_PROGRESSION_CONFIGURATION_REQUEST";
export const DELETE_PROGRESSION_CONFIGURATION_SUCCESS = "DELETE_PROGRESSION_CONFIGURATION_SUCCESS";
export const DELETE_PROGRESSION_CONFIGURATION_FAILURE = "DELETE_PROGRESSION_CONFIGURATION_FAILURE";

//agent commission config
export const FETCH_COMMISSION_CONFIGURATIONS_REQUEST = "FETCH_COMMISSION_CONFIGURATIONS_REQUEST";
export const FETCH_COMMISSION_CONFIGURATIONS_SUCCESS = "FETCH_COMMISSION_CONFIGURATIONS_SUCCESS";
export const FETCH_COMMISSION_CONFIGURATIONS_FAILURE = "FETCH_COMMISSION_CONFIGURATIONS_FAILURE";

export const CREATE_COMMISSION_CONFIGURATION_REQUEST = "CREATE_COMMISSION_CONFIGURATION_REQUEST";
export const CREATE_COMMISSION_CONFIGURATION_SUCCESS = "CREATE_COMMISSION_CONFIGURATION_SUCCESS";
export const CREATE_COMMISSION_CONFIGURATION_FAILURE = "CREATE_COMMISSION_CONFIGURATION_FAILURE";

export const UPDATE_COMMISSION_CONFIGURATION_REQUEST = "UPDATE_COMMISSION_CONFIGURATION_REQUEST";
export const UPDATE_COMMISSION_CONFIGURATION_SUCCESS = "UPDATE_COMMISSION_CONFIGURATION_SUCCESS";
export const UPDATE_COMMISSION_CONFIGURATION_FAILURE = "UPDATE_COMMISSION_CONFIGURATION_FAILURE";

export const DELETE_COMMISSION_CONFIGURATION_REQUEST = "DELETE_COMMISSION_CONFIGURATION_REQUEST";
export const DELETE_COMMISSION_CONFIGURATION_SUCCESS = "DELETE_COMMISSION_CONFIGURATION_SUCCESS";
export const DELETE_COMMISSION_CONFIGURATION_FAILURE = "DELETE_COMMISSION_CONFIGURATION_FAILURE";

//Agent Analytics
export const FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST ="FETCH_AGENT_ANALYTICS_DASHBOARD_REQUEST";
export const FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS ="FETCH_AGENT_ANALYTICS_DASHBOARD_SUCCESS";
export const FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE ="FETCH_AGENT_ANALYTICS_DASHBOARD_FAILURE";

export const FETCH_AGENT_PROGRAMME_REQUEST ="FETCH_AGENT_PROGRAMME_REQUEST";
export const FETCH_AGENT_PROGRAMME_SUCCESS ="FETCH_AGENT_PROGRAMME_SUCCESS";
export const FETCH_AGENT_PROGRAMME_FAILURE ="FETCH_AGENT_PROGRAMME_FAILURE";

export const FETCH_AGENT_CERTIFICATION_REQUEST ="FETCH_AGENT_CERTIFICATION_REQUEST";
export const FETCH_AGENT_CERTIFICATION_SUCCESS ="FETCH_AGENT_CERTIFICATION_SUCCESS";
export const FETCH_AGENT_CERTIFICATION_FAILURE ="FETCH_AGENT_CERTIFICATION_FAILURE";

export const FETCH_AGENT_OPERATIONS_REQUEST ="FETCH_AGENT_OPERATIONS_REQUEST";
export const FETCH_AGENT_OPERATIONS_SUCCESS ="FETCH_AGENT_OPERATIONS_SUCCESS";
export const FETCH_AGENT_OPERATIONS_FAILURE ="FETCH_AGENT_OPERATIONS_FAILURE";

export const FETCH_TOP_PERFORMING_AGENTS_REQUEST ="FETCH_TOP_PERFORMING_AGENTS_REQUEST";
export const FETCH_TOP_PERFORMING_AGENTS_SUCCESS ="FETCH_TOP_PERFORMING_AGENTS_SUCCESS";
export const FETCH_TOP_PERFORMING_AGENTS_FAILURE ="FETCH_TOP_PERFORMING_AGENTS_FAILURE";

export const FETCH_AGENT_PERFORMANCE_REQUEST ="FETCH_AGENT_PERFORMANCE_REQUEST";
export const FETCH_AGENT_PERFORMANCE_SUCCESS ="FETCH_AGENT_PERFORMANCE_SUCCESS";
export const FETCH_AGENT_PERFORMANCE_FAILURE ="FETCH_AGENT_PERFORMANCE_FAILURE";

export const FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST ="FETCH_AGENT_CUSTOMER_SATISFACTION_REQUEST";
export const FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS ="FETCH_AGENT_CUSTOMER_SATISFACTION_SUCCESS";
export const FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE ="FETCH_AGENT_CUSTOMER_SATISFACTION_FAILURE";

//agent certification
export const FETCH_AGENT_CERTIFICATIONS_REQUEST ="FETCH_AGENT_CERTIFICATIONS_REQUEST";
export const FETCH_AGENT_CERTIFICATIONS_SUCCESS ="FETCH_AGENT_CERTIFICATIONS_SUCCESS";
export const FETCH_AGENT_CERTIFICATIONS_FAILURE ="FETCH_AGENT_CERTIFICATIONS_FAILURE";

//Driver Trips
export const FETCH_DRIVER_TRIPS_REQUEST ="FETCH_DRIVER_TRIPS_REQUEST";
export const FETCH_DRIVER_TRIPS_SUCCESS ="FETCH_DRIVER_TRIPS_SUCCESS";
export const FETCH_DRIVER_TRIPS_FAILURE ="FETCH_DRIVER_TRIPS_FAILURE";

export const UPDATE_DRIVER_TRIP_REQUEST ="UPDATE_DRIVER_TRIP_REQUEST";
export const UPDATE_DRIVER_TRIP_SUCCESS ="UPDATE_DRIVER_TRIP_SUCCESS";
export const UPDATE_DRIVER_TRIP_FAILURE ="UPDATE_DRIVER_TRIP_FAILURE";

export const DELETE_DRIVER_TRIP_REQUEST ="DELETE_DRIVER_TRIP_REQUEST";
export const DELETE_DRIVER_TRIP_SUCCESS ="DELETE_DRIVER_TRIP_SUCCESS";
export const DELETE_DRIVER_TRIP_FAILURE ="DELETE_DRIVER_TRIP_FAILURE";